import { FutureAppointmentsMainAction } from "./appointments.future.main.types";

export const futureAppointmentsMainRequestAction = (): FutureAppointmentsMainAction => ({ type: 'FUTURE_APPOINTMENTS_MAIN_REQUEST' })

export const futureAppointmentsMainSuccessAction = (appointments: any[]): FutureAppointmentsMainAction => ({ type: 'FUTURE_APPOINTMENTS_MAIN_SUCCESS', params: appointments })

export const futureAppointmentsMainFailureAction = (error?: any) => ({ type: 'FUTURE_APPOINTMENTS_MAIN_FAILURE' } as const)
